import React, { useState } from "react";
import { FormControlLabel, Button, Checkbox } from "@material-ui/core";
import useBDocTranslator from "../hooks/useBDocTranslator";
import SelectAppt from "../providers/SelectAppt";
import ConsultationNotesEditor from "./ConsultationNotesEditor";

export default function ConsultationNotesDialog(props) {
  const [checked, setChecked] = useState(true);
  const { t } = useBDocTranslator();

  const handleChange = (event) => {
    setChecked(event.target.checked);
    props.handleVisibility(!checked);
  };

  return (
    <div style={{ width: "100%" }}>
      <SelectAppt
        onChange={(v) => props.setApptSelected(v)}
        value={props.apptSelected}
        patientId={props.patientId}
      />
      <ConsultationNotesEditor
        value={props.consultationNotesValue}
        onChange={(val) =>
          props.handleConsultationNotes({ target: { value: val } })
        }
        placeholder={t(
          "Consultation Notes Here, click to Pen button if you want minimize this section (the text entered will not be lost)"
        )}
        textareaClassName="mb-3 w-100 h-60-custom form-control col-md-12"
      />
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: "8px",
          gap: "12px",
        }}
      >
        <FormControlLabel
          control={
            <Checkbox
              checked={checked}
              onChange={handleChange}
              color="primary"
            />
          }
          label={t("Visible")}
          style={{ margin: 0 }}
        />
        <Button
          variant="contained"
          color="primary"
          onClick={props.handleSaveConsultationNotes}
          disabled={props.disabled}
          style={{ minWidth: "120px" }}
        >
          {t("Save")}
        </Button>
      </div>
    </div>
  );
}
